import { useState, useEffect } from 'react';
import { MatchReceipt, AccuracyMatchesResponse } from '../types/accuracy';

/** Fetch the match-wise Track Record receipts (newest first).
 *
 * ARCHIVE-1: the backend is decommissioned — the record is served from the
 * final static snapshot (`/track-record-final.json`, the API's last response,
 * baked into the frontend deploy). One fetch on mount; the refetch-on-focus
 * pattern (EVAL-3 / TRACK-4 #3) is gone because nothing can ever update the
 * record again.
 */
export function useAccuracyMatches() {
  const [matches, setMatches] = useState<MatchReceipt[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    (async () => {
      try {
        const res = await fetch('/track-record-final.json', {
          signal: controller.signal,
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data: AccuracyMatchesResponse = await res.json();
        if (!controller.signal.aborted) {
          setMatches(Array.isArray(data.matches) ? data.matches : []);
        }
      } catch (err: unknown) {
        if (controller.signal.aborted) return;
        setError(err instanceof Error ? err.message : String(err));
        setMatches([]);
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    })();

    return () => controller.abort();
  }, []);

  return { matches, loading, error };
}
